import { render, staticRenderFns } from "./Trustpilot.vue?vue&type=template&id=59c46384&"
import script from "./Trustpilot.vue?vue&type=script&lang=js&"
export * from "./Trustpilot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports